var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-input',_vm._g({ref:"input",attrs:{"clearable":true}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }